/* eslint-disable no-console */

/**
 * Sets an item into local storage
 * @param key Is the key of the object
 * @param value Is the value of the object
 * @returns A boolean, with true representing that it did successfully set it with false representing that it did not successfully set it
 */
const setLocalStorage = (key: string, value: object): boolean => {
	try {
		globalThis.localStorage.setItem(key, JSON.stringify(value));
		return true;
	} catch (error) {
		console.error(error);
		return false;
	}
};

/**
 * Gets an item from local storage
 * @param key Is the key that we are trying to retrieve
 * @returns Either the object (parsed) or null if it is did not find it
 */
const getLocalStorage = (key: string): object | null => {
	try {
		const data = globalThis.localStorage.getItem(key);
		return data ? JSON.parse(data) : null;
	} catch (error) {
		console.error(error);
		return null;
	}
};

/**
 * Removes an item from local storage
 * @param key The key of the object we want to remove
 * @returns A boolean, true if it was successfully removed, false if it was not removed
 */
const removeLocalStorage = (key: string): boolean => {
	try {
		globalThis.localStorage.removeItem(key);
		return true;
	} catch (error) {
		console.error(error);
		return false;
	}
};

/**
 * Clears local storage.
 * NB: You should not use this unless required as it clears the local storage for the application, which could have unforseen repercussions.
 * @returns A boolean, true if it was successfully cleared, false if it was not cleared
 */
const clearLocalStorage = (): boolean => {
	try {
		globalThis.localStorage.clear();
		return true;
	} catch (error) {
		console.error(error);
		return false;
	}
};

export { clearLocalStorage, getLocalStorage, removeLocalStorage, setLocalStorage };

